import type { PaperSize, Orientation } from '@/types';

// ISO and US sizes in mm (portrait, width x height)
const SIZES_PORTRAIT: Record<Exclude<PaperSize, 'Custom'>, { w: number; h: number }> = {
  A4: { w: 210, h: 297 },
  A5: { w: 148, h: 210 },
  A6: { w: 105, h: 148 },
  Letter: { w: 215.9, h: 279.4 },
  Legal: { w: 215.9, h: 355.6 },
  Thermal80: { w: 80, h: 297 }, // continuous roll — treat height as a long page
};

export function paperDimensions(
  size: PaperSize,
  orientation: Orientation,
  customW?: number,
  customH?: number,
): { width: number; height: number } {
  if (size === 'Custom') {
    const w = customW ?? 210;
    const h = customH ?? 297;
    return orientation === 'landscape'
      ? { width: h, height: w }
      : { width: w, height: h };
  }
  const dims = SIZES_PORTRAIT[size];
  return orientation === 'landscape'
    ? { width: dims.h, height: dims.w }
    : { width: dims.w, height: dims.h };
}

// 1 mm = 3.7795275591 px at 96 DPI
export const MM_TO_PX = 3.7795275591;
export const PX_TO_MM = 1 / MM_TO_PX;
